module.exports = __webpack_public_path__ + "cb3b77d2eaf495b76ae47f728f023771.pdf";